/* 
 * Export component file to be used on project
*/

import ResultNotFound from './ResultNotFound'
export default ResultNotFound